(function() {
  var cadIframe = document.getElementById('pcomiframe');
  if (!cadIframe) return;
  if (!cadIframe.src || cadIframe.src === 'about:blank') return;

  var webhook = window.cadenasZapierWebhook;
  if (!webhook) return;

  window.addEventListener('message', function(e) {
    if (e.data === 'PCOM_PART_GENERATED') {
      cadIframe.contentWindow.postMessage('PCOM_INFO', '*');
      return;
    }

    if (!(e.data instanceof Object) || !e.data.indexItemId) return;

    var params = new URLSearchParams();
    params.append('partId', e.data.partId || '');
    params.append('indexItemId', e.data.indexItemId || '');
    params.append('standardName', e.data.standardName || '');
    params.append('lina', e.data.lina || '');
    params.append('lastOrderNo', e.data.lastOrderNo || '');
    params.append('pageUrl', window.location.href);
    params.append('productTitle', document.title);

    if (e.data.user) {
      params.append('userEmail', e.data.user.email || '');
      params.append('userFirstname', e.data.user.firstname || '');
      params.append('userLastname', e.data.user.lastname || '');
      params.append('userCompany', e.data.user.company || '');
      params.append('userStreet', e.data.user.street || '');
      params.append('userCity', e.data.user.city || '');
      params.append('userState', e.data.user.state || '');
      params.append('userZip', e.data.user.zip || '');
      params.append('userPhone', e.data.user.phone || '');
    }

    if (typeof $wc_leads !== 'undefined' && $wc_leads.doc) {
      params.append('wcUrl', $wc_leads.doc.url || '');
      params.append('wcRef', $wc_leads.doc.ref || '');
      params.append('wcSearch', $wc_leads.doc.search || '');
    }

    fetch(webhook, { method: 'POST', body: params }).catch(function() {});
  });
})();
